<template>
	<transition name="pop" @after-leave="onTransitionLeave">
		<div v-show="visible" class="error-message" :style="style">
			<div class="error-message__inner">
				<p class="error-message__text">{{ message }}</p>
			</div>
		</div>
	</transition>
</template>

<script>
	
	export default {
		
		props: {
			
			anchorRect: {
				type: DOMRect,
				default() { return {} },
			},
			
			message: {
				type: String,
				default: "",
			},
			
			duration: {
				type: Number,
				default: 2500,
			},
			
		},
		
		computed: {
			
			style() {
				return {
					position: "absolute",
					top: `${this.anchorRect.top + window.scrollY}px`,
					left: `${this.anchorRect.left + (this.anchorRect.width / 2) - 160}px`,
				}
			}
			
		},
		
		methods: {
			
			onTransitionLeave() {
				this.$destroy(true);
				this.$el.parentNode.removeChild(this.$el);
			},
			
			startTimer() {
				if (this.duration > 0) {
					this.timer = setTimeout(() => {
						if (!this.closed) {
							this.close();
						}
					}, this.duration);
				}
			},
			
			close() {
				this.closed = true;
			},
			
		},
		
		watch: {
			closed(newVal) {
				if (newVal) {
					this.visible = false;
				}
			}
		},
		
		mounted() {
			this.startTimer();
		},
		
		data() {
			return {
				visible: false,
				closed: false,
			}
		},
		
	}
	
</script>

<style lang="scss">
	
	.error-message {
		
		position: relative;
		display: inline;
		transform-origin: 50% 100%;
		pointer-events: none;
		z-index: 10000;
		
		&__offset {
			left: 50%;
		}
		
		&__inner {
			
			position: relative;
			width: 320px;
			color: #FFF;
			background: #E6A23C;
			text-align: center;
			border-radius: 4px;
			padding: 12px;
			transform: translateY(calc(-100% - 12px));
			
			box-shadow:
				0 0.9px 1.3px rgba(0, 0, 0, 0.02),
				0 2.1px 3.2px rgba(0, 0, 0, 0.028),
				0 3.9px 6px rgba(0, 0, 0, 0.035),
				0 6.9px 10.7px rgba(0, 0, 0, 0.042),
				0 13px 20.1px rgba(0, 0, 0, 0.05),
				0 31px 48px rgba(0, 0, 0, 0.07)
			;
			
			&:after {
				content: '';
				position: absolute;
				top: 100%;
				left: 50%;
				margin-left: -8px;
				width: 0;
				height: 0;
				border-top: 8px solid #E6A23C;
				border-right: 8px solid transparent;
				border-left: 8px solid transparent;
			}
			
		}
		
		&__text {
			font-weight: 600;
			font-size: 14px;
			margin: 0;
		}
		
	}
	
	.pop {
		backface-visibility: hidden;
	}
	
	.pop-enter {
		transform: scale(0.8, 0.8);
		opacity: 0;
	}
	
	.pop-enter-to {
		transform: scale(1.0, 1.0);
		opacity: 1;
	}
	
	.pop-leave-to {
		opacity: 0;
	}
	
	.pop-enter-active {
		transition: all 125ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}
	
	.pop-leave-active {
		transition: all 125ms ease;
	}
	
</style>